export default __webpack_public_path__ + "static/0exchange-02f395a94ab04ee18285afdb49522650.jpg";